<div class="toast-stack">
    <div
    *ngFor="let toast of toastService.toasts$ | async"
    class="app-toast"
    [ngClass]="'toast-' + toast.type">

    <div class="toast-icon">
        <ng-container [ngSwitch]="toast.type">
        <span *ngSwitchCase="'success'">✓</span>
        <span *ngSwitchCase="'error'">!</span>
        <span *ngSwitchCase="'warning'">!</span>
        <span *ngSwitchDefault>i</span>
        </ng-container>
    </div>

    <div class="toast-content">
        <div class="toast-title">{{ toast.title }}</div>
        <div *ngIf="toast.message" class="toast-message">
        {{ toast.message }}
        </div>
    </div>

    <button
        type="button"
        class="toast-close"
        (click)="toastService.remove(toast.id)">
        ×
    </button>
    </div>
</div>